import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  body: {
    display: "flex",
    boxSizing: "border-box",
    minHeight: "calc(100vh - 70px)",
    flex: "1 1 100%",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    flex: "1 1 100%",
    "& > *": {
      margin: "40px",
      maxWidth: "calc(100% - 80px)",
      flex: "1 1 100%",
    },
    "@media (min-width: 1620px)": {
      "& > *": {
        margin: "40px 95px",
        maxWidth: "calc(100% - 190px)",
      },
    },
    "@media (max-width: 620px)": {
      overflowX: "auto",
      "& > *": {
        overflowX: "auto",
      },
    },
  },
});
